/* Version: 3.5.155 */
'use client';
var PROGRESS_VARIANT = {
  CIRCLE_INDETERMINATE: 'circle-indeterminate',
  IE_FALLBACK: 'ie-fallback',
  STYLIZED_M: 'stylized-m'
};

export { PROGRESS_VARIANT };
